import {
  BODY_SKINS,
  DIRECTION_DOWN,
  DIRECTION_LEFT,
  DIRECTION_RIGHT,
  DIRECTION_UP,
  INVENTORY,
  PLACEMENT_TYPE_CONVEYOR,
  PLACEMENT_TYPE_HERO,
  PLACEMENT_TYPE_ICE,
  PLACEMENT_TYPE_TELEPORT,
} from "../helpers/consts";

const ESCAPE_PROGRESS_FRAMES = 4;

export class Collision {
  constructor(forBody, level) {
    this.level = level;
    this.forBody = forBody;
    this.setPosition(forBody.x, forBody.y);
  }

  setPosition(x, y) {
    this.placementsAtPosition = this.getPlacementsAtPosition(
      x,
      y,
      this.forBody
    );
  }

  offsetPositionInDirection(x, y, direction) {
    const map = {
      [DIRECTION_LEFT]: [x - 1, y],
      [DIRECTION_RIGHT]: [x + 1, y],
      [DIRECTION_UP]: [x, y - 1],
      [DIRECTION_DOWN]: [x, y + 1],
    };
    const [newX, newY] = map[direction];
    this.setPosition(newX, newY);
  }

  getPlacementsAtPosition(x, y, forBody) {
    return this.level.placements.filter(
      (p) => p.x === x && p.y === y && p.id !== forBody.id
    );
  }

  getSkinForCurrentTile() {
    const firstTileWithNotNormalSkin = this.placementsAtPosition.find((p) => {
      return p.changeHeroSkinOnCollide(this.forBody) !== BODY_SKINS.NORMAL;
    });
    return (
      firstTileWithNotNormalSkin?.changeHeroSkinOnCollide(this.forBody) ??
      BODY_SKINS.NORMAL
    );
  }

  withSolidTile() {
    return this.placementsAtPosition.find((p) => p.isSolid(this.forBody));
  }

  withCompletesLevelTile() {
    return this.placementsAtPosition.find((p) =>
      p.completesLevelOnCollide(this.forBody)
    );
  }

  withTileAddsToInventory() {
    return this.placementsAtPosition.find((c) => {
      return (
        !c.hasBeenCollected && c.addsItemToInventoryOnCollide(this.forBody)
      );
    });
  }

  withIceTile() {
    return this.placementsAtPosition.find((c) => c.type === PLACEMENT_TYPE_ICE);
  }

  withIceTileCausesSlipping() {
    const isHeroWithIceBoots =
      this.forBody.type === PLACEMENT_TYPE_HERO &&
      this.level.inventory.has(INVENTORY.ICE_PICKUP);
    if (isHeroWithIceBoots) {
      return null;
    }
    return this.withIceTile();
  }

  withConveyorTile() {
    return this.placementsAtPosition.find(
      (c) => c.type === PLACEMENT_TYPE_CONVEYOR
    );
  }

  withTeleportTile() {
    return this.placementsAtPosition.find(
      (c) => c.type === PLACEMENT_TYPE_TELEPORT
    );
  }

  withTileAllowsMovementInDirection(directionString) {
    if (this.placementsAtPosition.length === 0) {
      return true;
    }
    const currentTile = this.placementsAtPosition[0];
    return currentTile?.allowsMovingInDirection(directionString);
  }

  withTileGivesLockedFrames() {
    return this.placementsAtPosition.find(
      (s) => s.givesPreAutoMoveFrames(this.forBody) > 0
    );
  }

  withTileSwitchesDoors() {
    return this.placementsAtPosition.find((s) =>
      s.switchesWallsOnCollide(this.forBody)
    );
  }

  withTileResetsInventory() {
    return this.placementsAtPosition.find((s) =>
      s.resetsInventoryOnCollide(this.forBody)
    );
  }

  withTileDropsBullet() {
    return this.placementsAtPosition.find((s) => {
      return s.dropsBulletOnCollide(this.forBody);
    });
  }

  withTileDamagesBody() {
    return this.placementsAtPosition.find((s) => {
      return (
        s.movingPixelsRemaining <= ESCAPE_PROGRESS_FRAMES &&
        s.damagesBodyOnCollide(this.forBody)
      );
    });
  }

  withBodyDamagesOther() {
    return this.placementsAtPosition.find((otherBody) => {
      return (
        otherBody.movingPixelsRemaining <= ESCAPE_PROGRESS_FRAMES &&
        this.forBody.damagesBodyOnCollide(otherBody)
      );
    });
  }

  withDoorThatCanBeUnlocked() {
    return this.placementsAtPosition.find((s) => {
      return s.isLockThatCanBeOpened && s.isLockThatCanBeOpened();
    });
  }
}
